import { Injectable } from '@angular/core';
import { ShopStorage } from '@x/ecommerce-shop/app/core/shop-storage/shop-storage.service';

export type RecentSearch = {
  searchText: string;
  timestamp: number;
};

@Injectable()
export class RecentSearchesService {
  constructor(private storage: ShopStorage) {}

  getRecentSearches(): RecentSearch[] {
    return this.storage.recentSearches || [];
  }

  addRecentSearch(search: string): void {
    const newSearch = { searchText: search.trim().toLowerCase(), timestamp: Date.now() };
    const recentSearches = this.storage.recentSearches;

    if (!recentSearches) {
      this.storage.recentSearches = [newSearch];
      return;
    }

    const indexOfCurrentSearch = recentSearches.findIndex(
      (s) => s.searchText === newSearch.searchText,
    );
    if (indexOfCurrentSearch !== -1) {
      recentSearches.splice(indexOfCurrentSearch, 1);
    }

    if (recentSearches.length >= 3) {
      recentSearches.pop();
    }

    this.storage.recentSearches = [newSearch, ...recentSearches];
  }
}
